module.exports = __webpack_public_path__ + "img/top_1.eff02db0.png";